// "polyfill" for max safe integer:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER
export const MAX_SAFE_INTEGER = 9007199254740991;
export const MIN_SAFE_INTEGER = -9007199254740991;
export const isSafe = n => {
  return n <= MAX_SAFE_INTEGER && n >= MIN_SAFE_INTEGER;
};